import type { ReactNode } from "react";
import { Disclosure } from "@headlessui/react";
import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface DefaultEditorV2CollapsableProps {
  children: ReactNode;
  defaultOpen?: boolean;
  title: ReactNode;
}

export const DefaultEditorV2Collapsable = ({
  title,
  children,
  defaultOpen = true,
}: DefaultEditorV2CollapsableProps) => (
  <Disclosure defaultOpen={defaultOpen}>
    {({ open }) => (
      <div className="flex flex-col">
        <Disclosure.Button
          className={classNames("flex items-center justify-between px-6 py-3")}
        >
          <Typography.LabelSm weight="semibold">{title}</Typography.LabelSm>
          <span className="flex size-4 items-center justify-center">
            <Icon
              type="16-chevron-down"
              size={16}
              className={classNames({
                "rotate-180": open,
              })}
              aria-label={t(
                open
                  ? "builder_ui.editor.collapse_section"
                  : "builder_ui.editor.expand_section",
              )}
            />
          </span>
        </Disclosure.Button>
        <Disclosure.Panel unmount={false}>{children}</Disclosure.Panel>
      </div>
    )}
  </Disclosure>
);
